import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

const pathMap: Record<string, string> = {
  dashboard: 'Дашборд',
  users: 'Пользователи',
  wallets: 'Кошельки',
  transactions: 'Транзакции',
  kyc: 'KYC запросы',
  audit_logs: 'Журнал аудита',
  settings: 'Настройки',
  manager_roles: 'Роли менеджеров'
};

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Если находимся на главной странице, не показываем хлебные крошки
  if (pathnames.length === 0) {
    return null;
  }

  return (
    <Box sx={{ px: 2, py: 1, bgcolor: 'background.paper', borderTop: 1, borderColor: 'divider' }}>
      <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
        <Link component={RouterLink} to="/" color="inherit">
          Главная
        </Link>
        
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const displayName = pathMap[value] || value;
          
          return last ? (
            <Typography color="textPrimary" key={to}>
              {displayName}
            </Typography>
          ) : (
            <Link component={RouterLink} to={to} key={to} color="inherit">
              {displayName}
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
};

export default Breadcrumbs; 